import { isPendingAssistantText } from '@/constants/chat'
import { normalizeMessages } from '@/features/chat/messageNormalize'
import { serverHasAppendedMessages } from './serverHasAppendedMessages'

function isVersioned(message) {
  const versionIndex = message.versionIndex ?? 0
  const assistantVersionIndex = message.assistantVersionIndex ?? 0
  return versionIndex > 0 || assistantVersionIndex > 0
}

function isUnstable(message) {
  return Boolean(
    isPendingAssistantText(message.text ?? '') ||
      message.demoStreamActive ||
      message.phase1Interrupted,
  )
}

function turnRows(messages) {
  const turns = []
  let current = null
  for (const message of normalizeMessages(messages)) {
    if (!message || typeof message !== 'object') continue
    if (message.role === 'user') {
      current = { userText: String(message.text ?? ''), assistantText: '' }
      turns.push(current)
    } else if (message.role === 'assistant' && current && !current.assistantText) {
      current.assistantText = String(message.text ?? '')
    }
  }
  return turns
}

function sameUserPrefix(localTurns, serverTurns) {
  return localTurns.every((turn, index) => turn.userText === serverTurns[index]?.userText)
}

export function shouldReplaceWithServerMessages(localMessages = [], serverMessages = []) {
  if (!serverMessages.length) return false
  const local = normalizeMessages(localMessages)
  if (!local.length) return true
  if (local.some((message) => isVersioned(message) || isUnstable(message))) return false
  // Checked before the turn comparison, which counts only user-led exchanges
  // and so cannot see a message a scheduled run appended on its own.
  if (serverHasAppendedMessages(local, serverMessages)) return true
  const localTurns = turnRows(local)
  const serverTurns = turnRows(serverMessages)
  if (!localTurns.length || serverTurns.length < localTurns.length) return false
  if (!sameUserPrefix(localTurns, serverTurns)) return false
  if (serverTurns.length > localTurns.length) return true
  return localTurns.some((turn, index) => {
    const serverText = serverTurns[index]?.assistantText ?? ''
    return Boolean(serverText.trim() && turn.assistantText !== serverText)
  })
}
